export default __webpack_public_path__ + "static/media/checkCirсleIcon.b7f49343.svg";